module.exports = __webpack_public_path__ + "img/go-to-shop.7b6dc63f.svg";